import { render } from "./ProfileUser.vue?vue&type=template&id=845a2fd0"
import script from "./ProfileUser.vue?vue&type=script&lang=js"
export * from "./ProfileUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__